import React from 'react';

import { subscriptionType } from '~/features/subscriptions/subscription';

const CATEGORY = {
  [subscriptionType.LAWN_PLAN]: {
    fill: '#6ed887',
    outline: '#38996C',
    tape: '#3fbd75',
  },
  [subscriptionType.PEST]: {
    fill: '#89d4ea',
    outline: '#007290',
    tape: '#0090b0',
  },
  default: {
    fill: '#ffe6bd',
    outline: '#ffc059',
    tape: '#ffc059',
  },
};

const PackageIcon = ({ className, category }) => {
  const theme = CATEGORY[category] || CATEGORY.default;
  return (
    <svg
      className={className}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.364 13.821l7.073 2.786 7.072-2.786V4.285L8.437 1.392 1.364 4.285v9.536z"
        fill="#fff"
      />
      <path
        fill={theme.fill}
        d="M15.51 13.821l.087-9.576L9.3 1.725 2.082 4.677v9.427l6.355 2.503 7.072-2.786z"
      />
      <path
        stroke={theme.outline}
        clipRule="evenodd"
        d="M1 4.043L8.437 1l7.436 3.043V14.07L8.437 17 1 14.07V4.044z"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke={theme.outline}
        d="M1 4.042l7.437 2.93 7.206-2.84M8.437 17V6.972"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill={theme.tape}
        d="M13.175 4.824L6.513 2.18l-2.46 1.007 7.28 2.888v3.17l1.842-.726V4.824z"
      />
    </svg>
  );
};

export default PackageIcon;
